import * as actionTypes from "./actionTypes";
import initialState from "reducers/initialState";

export const assetImagesReducer = (state = initialState.assetData.images, action) => {
  switch (action.type) {
    case actionTypes.DOWNLOAD_ASSET_IMAGE_SUCCESS: {
      return {
        ...state,
        [action.payload.id]: action.payload.image
      };
    }

    default:
      return state;
  }
};
